export const STICKY_COLUMN_POSITION = {
    LEFT: 'left',
    RIGHT: 'right',
};
